import React from 'react';
import { Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import { useBrandColors } from '../hooks/useBrandColors';

interface PageHeaderProps {
  icon: SvgIconComponent;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  children 
}) => {
  const brandColors = useBrandColors();

  const styles = {
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      marginBottom: subtitle ? '16px' : '32px'
    },
    title: {
      fontSize: '28px',
      fontWeight: '600',
      color: brandColors.textPrimary
    },
    subtitle: {
      fontSize: '16px',
      color: '#666',
      marginBottom: '24px'
    }
  };

  return (
    <>
      {/* Header */}
      <div style={styles.header}>
        <Icon sx={{ fontSize: '32px', color: brandColors.primary }} />
        <h1 style={styles.title}>{title}</h1>
        <div style={{ marginLeft: 'auto' }}>
          {children}
        </div>
      </div>
      
      {subtitle && (
        <p style={styles.subtitle}>
          {subtitle}
        </p>
      )}
    </>
  );
};
